import BaseExpansionPanel from '@material-ui/core/ExpansionPanel'

const ExpansionPanel = BaseExpansionPanel

export default ExpansionPanel
